import Vue from 'vue';
import Vuex from 'vuex';
import TronWeb from "tronweb";
import cookies from "vue-cookies"
//import { KYC,Token } from "../../embarkArtifacts/contracts";
Vue.use (Vuex);

const HttpProvider = TronWeb.providers.HttpProvider;
const fullNode = new HttpProvider("https://api.shasta.trongrid.io");
const solidityNode = new HttpProvider("https://api.shasta.trongrid.io");
const eventServer = new HttpProvider("https://api.shasta.trongrid.io");
  //const pk="501AD9779D596A58E004BFDF51848FFF7D6E6C65D2CF914E149067FADA45162B"
   const tronWeb = new TronWeb(fullNode,solidityNode,eventServer)
   let address=cookies.get('address')
   console.log(address)
   if(address==null){
     address="TXPv2PQ6qbbeStFhUwnAyxxj34pWASBcQe"
   }
    tronWeb.setAddress(address)
  // tronWeb.setPrivateKey(pk);
//  let address= tronWeb.address.fromPrivateKey(pk);
  
  
  //  tronWeb.defaultAddress = {
  //    hex: TronWeb.address.toHex(address),
  //    base58: address
  //  };
  
 
 //cookies.set('address',address);

   
export const store = new Vuex.Store ({
  state: {
    loggedIn: undefined,
    currentAddress: undefined,
    currentBalance: 0,
    depositedAmount:0.0,
    loading: false,
    userData: [],
    name: '',
    KYC:undefined,
    PayID:undefined,
    address:"TVkCLxAuQ3MrcSXfGG8NAu9Xz4CAt2ZcsB",
    payId:"TKtW3oqBbbEMuacxwKbz1rGmtq3ZufDEBC",
    tokenAddress:"TV6AJPFRhosBZCdqEqxz2TMP97DCpXYTwc",
    Token:undefined,
    email:'',
    // url:"https://bdt-defi-api.herokuapp.com",
    url:'https://test-app-180.herokuapp.com',
    eventUrl:'https://kyc-crypto-events-test.herokuapp.com/api/',
    tronWeb:tronWeb
  },
  mutations: {
    setAddress: (state, data) => {
      state.currentAddress = data;
    },
    setUserData: (state, data) => {
      state.userData = data;
    },
    setBalance: (state, data) => {
      state.currentBalance = data;
    },

    setDepositedAmount:(state,data)=>{
      state.depositedAmount=data;
    },
    setName: (state, data) => {
      state.name = data;
    },
  },
  actions: {
    getAddress: async ({commit,state}) => {
      // let add = await state.web3.eth.getAccounts ();
      // if (add[0] != undefined) {
      //   commit ('setAddress', add[0]);
      // }
    },
    getCurrentBalance: async ({commit,state}, address) => {
      let balance = await state.tronWeb.trx.getBalance (address);
      balance = await state.tronWeb.fromSun(balance.toString ());
      let bal;
      if(balance<=0){
        bal=parseFloat(balance).toFixed(2);
      }else{
        bal=parseFloat(balance).toFixed(2);
      }
    
      commit ('setBalance',bal);
    },
    getName: async (context, name) => {
      context.commit ('setName', name);
    },
    getDepositedAmount:async ({commit,state},address)=>{

      let amount=await state.KYC.paidAmountParty(address).call();
     let balance = await state.tronWeb.fromSun (amount.toString());
      let bal;
      if(balance<=0){
        bal=parseFloat(balance).toFixed(2);
      }else{
        bal=parseFloat(balance).toFixed(2);
      }
      commit('setDepositedAmount',bal);
    },
    setContract:async({commit,state})=>{
      state.KYC=await tronWeb.contract().at(state.address)
      state.Token=await tronWeb.contract().at(state.tokenAddress)
      state.PayID=await tronWeb.contract().at(state.payId)
    }
  },
  modules: {},
});
